import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import './css/classes.css'
import './css/elements.css'
import './css/styles.css'
import './css/theme.css'
import './css/tables.css'
import App from './App'
// import PushNotification from './util/PushNotification'
import * as serviceWorker from './serviceWorker'

ReactDOM.render(
  (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  ),
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register()

/*
const config = {
  apiKey: "AIzaSyDgDhY0Yt9rZn-CnOhif-NLPMar9lCvtG4",
  authDomain: "teambrew-1875.firebaseapp.com",
  databaseURL: "https://teambrew-1875.firebaseio.com",
  projectId: "teambrew-1875",
  storageBucket: "teambrew-1875.appspot.com",
  messagingSenderId: "662119356563"
}
new PushNotification(config)
*/
